import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/images/cs_avatar.png'
import _imports_1 from '@/app/ui/assets/svg/user-avatar-square.svg'
import _imports_2 from '@/app/ui/assets/svg/check-circle.svg'
import _imports_3 from '@/app/ui/assets/svg/ics_o_clock2.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-461bf2e2")

_pushScopeId("data-v-461bf2e2")
const _hoisted_1 = {
  id: "conversation-container",
  class: "overflow-auto pt-6 pb-4 flex-auto flex w-full history-chat-container"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full absolute top-0 p-2.5 flex flex-row rounded-b-xl bg-blue-lp-800 text-white text-sm justify-between items-center z-10"
}
const _hoisted_3 = { class: "font-medium" }
const _hoisted_4 = {
  key: 1,
  class: "align-top pt-10 w-full"
}
const _hoisted_5 = {
  key: 2,
  class: "w-full"
}
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-8"
}
const _hoisted_7 = { class: "flex flex-col gap-2" }
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "flex flex-col gap-2" }
const _hoisted_10 = { class: "flex flex-col gap-2" }
const _hoisted_11 = { class: "flex flex-col gap-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { id: "infinite-scroll-conversation-chat" }, null, -1)
const _hoisted_13 = {
  key: 0,
  class: "absolute font-medium text-xs text-white px-1 text-center bg-red-lp-100 rounded right-0"
}
const _hoisted_14 = { class: "mt-3" }
const _hoisted_15 = {
  key: 0,
  src: _imports_0,
  class: "w-9 h-9 object-cover align-top rounded",
  alt: "User"
}
const _hoisted_16 = {
  key: 1,
  src: _imports_1,
  class: "w-9 h-9 object-cover align-top",
  alt: "User"
}
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "w-full flex flex-col text-sm gap-0.5 text-gray-lp-300" }
const _hoisted_19 = { class: "w-full flex flex-row flex-wrap gap-x-1 font-semibold" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px" }, "•", -1)
const _hoisted_21 = { class: "text-gray-lp-600 font-normal" }
const _hoisted_22 = { class: "mb-2.5 flex flex-row justify-between" }
const _hoisted_23 = { class: "flex flex-row gap-x-1 items-center" }
const _hoisted_24 = { class: "flex flex-row gap-x-1 items-center" }
const _hoisted_25 = {
  key: 0,
  src: _imports_2,
  class: "w-6",
  alt: "check"
}
const _hoisted_26 = {
  key: 2,
  src: _imports_3,
  class: "w-6",
  alt: "clock"
}
const _hoisted_27 = { class: "mb-1 font-semibold text-gray-lp-300" }
const _hoisted_28 = { class: "font-medium text-gray-lp-600 inline" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode("Dieskalasi ke: ")
const _hoisted_30 = { class: "text-gray-lp-300 ml-1 inline" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "inline ql-text" }
const _hoisted_34 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_35 = { class: "inline font-semibold text-gray-lp-800" }
const _hoisted_36 = { class: "inline" }
const _hoisted_37 = {
  key: 2,
  class: "space-y-2"
}
const _hoisted_38 = { class: "flex flex-row flex-wrap gap-1 max-w-[calc((40px+0.25rem)*6)]" }
const _hoisted_39 = { class: "relative border border-gray-lp-1400 rounded-lg p-1" }
const _hoisted_40 = {
  key: 2,
  class: ""
}
const _hoisted_41 = {
  key: 1,
  class: "w-full text-sm text-gray-lp-300"
}
const _hoisted_42 = {
  key: 0,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Agen CS bertugas ")
const _hoisted_44 = { class: "font-semibold" }
const _hoisted_45 = /*#__PURE__*/_createTextVNode(" dipindahkan ke ")
const _hoisted_46 = { class: "font-semibold" }
const _hoisted_47 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_48 = { class: "text-gray-lp-600" }
const _hoisted_49 = {
  key: 1,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Prioritas tiket diubah ke ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" oleh ")
const _hoisted_52 = { class: "font-semibold" }
const _hoisted_53 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_54 = { class: "text-gray-lp-600" }
const _hoisted_55 = {
  key: 2,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Kategori kendala")
const _hoisted_57 = { class: "font-semibold" }
const _hoisted_58 = /*#__PURE__*/_createTextVNode(" diubah ke ")
const _hoisted_59 = { class: "font-semibold" }
const _hoisted_60 = /*#__PURE__*/_createTextVNode(" oleh ")
const _hoisted_61 = { class: "font-semibold" }
const _hoisted_62 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_63 = { class: "text-gray-lp-600" }
const _hoisted_64 = {
  key: 3,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_65 = /*#__PURE__*/_createTextVNode("Tugas eskalasi ")
const _hoisted_66 = { class: "font-semibold" }
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" diselesaikan oleh ")
const _hoisted_68 = { class: "font-semibold" }
const _hoisted_69 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_70 = { class: "text-gray-lp-600" }
const _hoisted_71 = {
  key: 4,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_72 = /*#__PURE__*/_createTextVNode("Tiket ")
const _hoisted_73 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-purple-lp-700" }, "dalam eskalasi", -1)
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" oleh ")
const _hoisted_75 = { class: "font-semibold" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" untuk ")
const _hoisted_77 = { class: "font-semibold" }
const _hoisted_78 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_79 = { class: "text-gray-lp-600" }
const _hoisted_80 = {
  key: 5,
  class: "w-full flex flex-row flex-wrap justify-center gap-x-1"
}
const _hoisted_81 = /*#__PURE__*/_createTextVNode("Tiket ")
const _hoisted_82 = { class: "font-semibold" }
const _hoisted_83 = /*#__PURE__*/_createVNode("div", { class: "text-gray-lp-800 text-16px font-semibold" }, "•", -1)
const _hoisted_84 = { class: "text-gray-lp-600" }
const _hoisted_85 = {
  key: 2,
  class: "flex flex-row items-center relative mt-3"
}
const _hoisted_86 = /*#__PURE__*/_createVNode("div", {
  class: "w-full bg-red-lp-100",
  style: {"height":"1px"}
}, null, -1)
const _hoisted_87 = /*#__PURE__*/_createVNode("div", { class: "absolute font-medium text-xs text-white px-1 text-center bg-red-lp-100 rounded right-0" }, "Baru", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_ImagePreview = _resolveComponent("ImagePreview")!
  const _component_ModalFinishIssue = _resolveComponent("ModalFinishIssue")!
  const _component_ModalSuccessFinish = _resolveComponent("ModalSuccessFinish")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      (_ctx.historyChatData.data.unreadCount && !_ctx.errorState)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, _toDisplayString(_ctx.historyChatData.data.unreadCount) + " pesan baru pada jam " + _toDisplayString(_ctx.getTime(_ctx.historyChatData.data.firstUnreadMessageAt)) + ".", 1),
            _createVNode("button", {
              class: "font-bold underline cursor-pointer",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.readUnreadMessage && _ctx.readUnreadMessage(...args)))
            }, "Lihat pesan")
          ]))
        : _createCommentVNode("", true),
      (_ctx.errorState)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_ctx.errorState === _ctx.CLIENT_ERROR || _ctx.errorState === _ctx.INTERNAL_SERVER_ERROR)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 0,
                  customClass: "error-class",
                  customHeaderMessage: "Terjadi gangguan sistem",
                  customMessage: "Klik \"Muat ulang\" atau coba beberapa saat lagi.",
                  icon: "error-token-ngen",
                  buttonAction: {
          title: 'Muat ulang',
          textColor: 'white',
          fontWeight: 'semibold',
          iconLeft: 'reload-white',
          sizeIcon: '12px'
        },
                  onAction: _cache[2] || (_cache[2] = () => _ctx.getHistoryChat())
                }))
              : _createCommentVNode("", true),
            (_ctx.errorState === _ctx.INTERNET_ERROR)
              ? (_openBlock(), _createBlock(_component_EmptyState, {
                  key: 1,
                  icon: "error-internet",
                  customClass: "error-class",
                  customHeaderMessage: "Jaringan internet terputus",
                  customMessage: "Periksa jaringan internal Anda lalu klik \"Muat ulang\".",
                  buttonAction: {
          title: 'Muat ulang',
          textColor: 'white',
          fontWeight: 'semibold',
          iconLeft: 'reload-white',
          sizeIcon: '12px'
        },
                  onAction: _cache[3] || (_cache[3] = () => _ctx.getHistoryChat())
                }))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_5, [
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, [
                    _createVNode(_component_Skeleton, { width: "90%" }),
                    _createVNode(_component_Skeleton, { width: "70%" }),
                    _createVNode(_component_Skeleton, { width: "100%" }),
                    _createVNode(_component_Skeleton, { width: "50%" })
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_Skeleton, { width: "90%" }),
                    _createVNode(_component_Skeleton, { width: "70%" }),
                    _createVNode(_component_Skeleton, { width: "100%" }),
                    _createVNode(_component_Skeleton, { width: "50%" })
                  ]),
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_Skeleton, { width: "90%" }),
                    _createVNode(_component_Skeleton, { width: "70%" }),
                    _createVNode(_component_Skeleton, { width: "100%" }),
                    _createVNode(_component_Skeleton, { width: "50%" })
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode(_component_Skeleton, { width: "90%" }),
                    _createVNode(_component_Skeleton, { width: "70%" }),
                    _createVNode(_component_Skeleton, { width: "100%" }),
                    _createVNode(_component_Skeleton, { width: "50%" })
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _createVNode(_component_Skeleton, { width: "90%" }),
                    _createVNode(_component_Skeleton, { width: "70%" }),
                    _createVNode(_component_Skeleton, { width: "100%" }),
                    _createVNode(_component_Skeleton, { width: "50%" })
                  ])
                ]))
              : _createCommentVNode("", true),
            _hoisted_12,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupedConversation, (group, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                _createVNode("div", {
                  class: ["flex flex-row items-center gap-3 relative", { 'mt-3' : index !== 0 }]
                }, [
                  _createVNode("div", {
                    class: ["w-full", `${group.isGroupingUnread && group.groupDateUnread && _ctx.isHighlight ? 'bg-red-lp-100' : 'bg-gray-lp-1400'}`],
                    style: {"height":"1px"}
                  }, null, 2),
                  _createVNode("div", {
                    class: ["font-medium text-xs whitespace-nowrap text-center", `${group.isGroupingUnread && group.groupDateUnread && _ctx.isHighlight ? 'text-red-lp-100' : 'text-gray-lp-600'}`]
                  }, _toDisplayString(group.date), 3),
                  _createVNode("div", {
                    class: ["w-full", `${group.isGroupingUnread && group.groupDateUnread && _ctx.isHighlight ? 'bg-red-lp-100' : 'bg-gray-lp-1400'}`],
                    style: {"height":"1px"}
                  }, null, 2),
                  (group.isGroupingUnread && group.groupDateUnread && _ctx.isHighlight)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, "Baru"))
                    : _createCommentVNode("", true)
                ], 2),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.items, (conversation, index) => {
                  return (_openBlock(), _createBlock("div", {
                    key: index,
                    id: `conversation-element-${conversation.id}`
                  }, [
                    _createVNode("div", _hoisted_14, [
                      (_ctx.isCardView(conversation))
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: ["flex flex-row w-full p-1 gap-3", `${ conversation.isMentioned && conversation.type === 'CHAT' ? 'bg-red-lp-1100 hover:bg-red-lp-2100 border-l-2 border-red-lp-100' : 'hover:bg-gray-lp-1000' }`]
                          }, [
                            (conversation.type === 'ESCALATION_NOTE' || !conversation.createdByPartnerCode)
                              ? (_openBlock(), _createBlock("img", _hoisted_15))
                              : (_openBlock(), _createBlock("img", _hoisted_16)),
                            _createVNode("div", _hoisted_17, [
                              _createVNode("div", _hoisted_18, [
                                _createVNode("div", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(_ctx.mapChatLabel(conversation)), 1),
                                  _hoisted_20,
                                  _withDirectives(_createVNode("div", _hoisted_21, null, 512), [
                                    [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                  ])
                                ]),
                                (conversation.type === 'ESCALATION_NOTE')
                                  ? (_openBlock(), _createBlock("div", {
                                      key: 0,
                                      class: ["flex flex-col p-2.5 rounded-xl border max-w-400px", `${ conversation.value.isSolved ? 'border-green-lp-300 bg-green-lp-1400' : 'border-purple-lp-400 bg-aqua-lp-600' }`]
                                    }, [
                                      _createVNode("div", _hoisted_22, [
                                        _createVNode("div", _hoisted_23, [
                                          _createVNode(_component_Icons, {
                                            name: "clipboard",
                                            color: `${conversation.value.isSolved ? '#006644' : '#4F46A4'}`
                                          }, null, 8, ["color"]),
                                          _createVNode("div", {
                                            class: ["font-medium", `${conversation.value.isSolved ? 'text-green-lp-200' : 'text-purple-lp-800'}`]
                                          }, "Tugas eskalasi", 2)
                                        ]),
                                        _createVNode("div", _hoisted_24, [
                                          _createVNode("div", {
                                            class: ["font-medium", `${conversation.value.isSolved ? 'text-green-lp-400' : 'text-purple-lp-700'}`]
                                          }, _toDisplayString(conversation.value.isSolved ? 'Selesai' : conversation.isMentioned ? 'Selesaikan kendala' : 'Dalam proses'), 3),
                                          (conversation.value.isSolved)
                                            ? (_openBlock(), _createBlock("img", _hoisted_25))
                                            : (conversation.isMentioned)
                                              ? (_openBlock(), _createBlock(_component_Checkbox, {
                                                  key: 1,
                                                  name: "finish",
                                                  id: index,
                                                  "v-model": false,
                                                  onClick: _ctx.onShowModalFinish
                                                }, null, 8, ["id", "onClick"]))
                                              : (_openBlock(), _createBlock("img", _hoisted_26))
                                        ])
                                      ]),
                                      _createVNode("div", _hoisted_27, _toDisplayString(conversation.value.note), 1),
                                      _createVNode("div", _hoisted_28, [
                                        _hoisted_29,
                                        _withDirectives(_createVNode("div", _hoisted_30, null, 512), [
                                          [_directive_sanitize_html, _ctx.getPartnerName(conversation)]
                                        ])
                                      ])
                                    ], 2))
                                  : (_openBlock(), _createBlock("div", _hoisted_31, [
                                      (conversation.type === 'CHAT')
                                        ? (_openBlock(), _createBlock("div", _hoisted_32, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(conversation.value.mentions, (mention, index) => {
                                              return (_openBlock(), _createBlock("div", {
                                                key: index,
                                                class: "font-semibold text-red-lp-100 bg-red-lp-1100 inline-block mr-1"
                                              }, "@" + _toDisplayString(mention.type === 'agent' ? 'Lion parcel' : mention.code) + " - " + _toDisplayString(mention.name), 1))
                                            }), 128)),
                                            _withDirectives(_createVNode("div", _hoisted_33, null, 512), [
                                              [_directive_sanitize_html, conversation.value.message]
                                            ])
                                          ]))
                                        : (_openBlock(), _createBlock("div", _hoisted_34, [
                                            _withDirectives(_createVNode("div", _hoisted_35, null, 512), [
                                              [_directive_sanitize_html, conversation.value.title]
                                            ]),
                                            _withDirectives(_createVNode("div", _hoisted_36, null, 512), [
                                              [_directive_sanitize_html, conversation.value.message]
                                            ])
                                          ])),
                                      (conversation.value.attachments.length > 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_37, [
                                            _createVNode("div", _hoisted_38, [
                                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(conversation.value.attachments, (item, index) => {
                                                return (_openBlock(), _createBlock("div", {
                                                  key: index,
                                                  class: "relative"
                                                }, [
                                                  _createVNode("div", _hoisted_39, [
                                                    (_ctx.isImageFile(item.ext))
                                                      ? (_openBlock(), _createBlock("img", {
                                                          key: 0,
                                                          src: item.url,
                                                          alt: item.name,
                                                          class: "h-10 w-10 object-cover rounded-lg cursor-pointer",
                                                          onClick: () => _ctx.openImagePreview(index, conversation.id)
                                                        }, null, 8, ["src", "alt", "onClick"]))
                                                      : (_openBlock(), _createBlock("img", {
                                                          key: 1,
                                                          src: 
                                'data:image/svg+xml;utf8,' +
                                  encodeURIComponent(
                                    `<svg viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M9.69462 0H24L36 12V34.7926C36 37.6711 33.5088 40 30.4403 40H9.57031C6.49114 40 4 37.6711 4 34.7926V5.20733C3.99995 2.32878 6.61539 0 9.69462 0Z' fill='${_ctx.getFileColor(
                                      item.ext
                                    )}'/><path d='M24.0257 8.16V0L36 12H28.0171C24.4248 12 23.8593 9.44 24.0257 8.16Z' fill='white' fill-opacity='0.3'/></svg>`
                                  )
                              ,
                                                          alt: item.name,
                                                          class: "h-10 w-10 object-cover rounded-lg cursor-pointer",
                                                          onClick: () => _ctx.downloadFile(item.url)
                                                        }, null, 8, ["src", "alt", "onClick"])),
                                                    (!_ctx.isImageFile(item.ext))
                                                      ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                                          _createVNode("span", {
                                                            class: " text-10px font-bold absolute bottom-3 transform left-1/2 -translate-x-1/2 cursor-pointer",
                                                            style: {
                                  color: item.ext === 'csv' ? '#626262' : '#ffffff'
                                },
                                                            onClick: () => _ctx.downloadFile(item.url)
                                                          }, _toDisplayString(item.ext.toUpperCase()), 13, ["onClick"])
                                                        ]))
                                                      : _createCommentVNode("", true)
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.showImagePreview && _ctx.showImageConversationId === conversation.id)
                                        ? (_openBlock(), _createBlock(_component_ImagePreview, {
                                            key: 3,
                                            title: "Lampiran",
                                            images: _ctx.mapConversationImages(conversation),
                                            "title-images": _ctx.mapConversationTitle(conversation),
                                            "initial-index": _ctx.selectedImage,
                                            onClose: _ctx.closeImagePreview
                                          }, null, 8, ["images", "title-images", "initial-index", "onClose"]))
                                        : _createCommentVNode("", true)
                                    ]))
                              ])
                            ])
                          ], 2))
                        : (_openBlock(), _createBlock("div", _hoisted_41, [
                            (conversation.type === 'CS_AGENT_CHANGE')
                              ? (_openBlock(), _createBlock("div", _hoisted_42, [
                                  _hoisted_43,
                                  _withDirectives(_createVNode("div", _hoisted_44, null, 512), [
                                    [_directive_sanitize_html, conversation.value.oldAgent]
                                  ]),
                                  _hoisted_45,
                                  _withDirectives(_createVNode("div", _hoisted_46, null, 512), [
                                    [_directive_sanitize_html, conversation.value.newAgent]
                                  ]),
                                  _hoisted_47,
                                  _withDirectives(_createVNode("div", _hoisted_48, null, 512), [
                                    [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                  ])
                                ]))
                              : (conversation.type === 'PRIORITY_CHANGE')
                                ? (_openBlock(), _createBlock("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createVNode("div", {
                                      class: ["font-semibold", `${_ctx.mappingListPriority(conversation.value.newPriority).color}`]
                                    }, _toDisplayString(_ctx.mappingListPriority(conversation.value.newPriority).label), 3),
                                    _hoisted_51,
                                    _withDirectives(_createVNode("div", _hoisted_52, null, 512), [
                                      [_directive_sanitize_html, conversation.createdName]
                                    ]),
                                    _hoisted_53,
                                    _withDirectives(_createVNode("div", _hoisted_54, null, 512), [
                                      [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                    ])
                                  ]))
                                : (conversation.type === 'CATEGORY_CHANGE')
                                  ? (_openBlock(), _createBlock("div", _hoisted_55, [
                                      _hoisted_56,
                                      _createVNode("div", _hoisted_57, "\"" + _toDisplayString(conversation.value.oldCategory) + "\"", 1),
                                      _hoisted_58,
                                      _createVNode("div", _hoisted_59, "\"" + _toDisplayString(conversation.value.newCategory) + "\"", 1),
                                      _hoisted_60,
                                      _withDirectives(_createVNode("div", _hoisted_61, null, 512), [
                                        [_directive_sanitize_html, conversation.createdName]
                                      ]),
                                      _hoisted_62,
                                      _withDirectives(_createVNode("div", _hoisted_63, null, 512), [
                                        [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                      ])
                                    ]))
                                  : (conversation.type === 'ESCALATE_DONE')
                                    ? (_openBlock(), _createBlock("div", _hoisted_64, [
                                        _hoisted_65,
                                        _withDirectives(_createVNode("div", _hoisted_66, null, 512), [
                                          [_directive_sanitize_html, _ctx.getPartnerName(conversation)]
                                        ]),
                                        _hoisted_67,
                                        _withDirectives(_createVNode("div", _hoisted_68, null, 512), [
                                          [_directive_sanitize_html, conversation.createdBy ? _ctx.userInformationLabel(conversation) : conversation.createdName]
                                        ]),
                                        _hoisted_69,
                                        _withDirectives(_createVNode("div", _hoisted_70, null, 512), [
                                          [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                        ])
                                      ]))
                                    : (conversation.type === 'ESCALATE_TO')
                                      ? (_openBlock(), _createBlock("div", _hoisted_71, [
                                          _hoisted_72,
                                          _hoisted_73,
                                          _hoisted_74,
                                          _withDirectives(_createVNode("div", _hoisted_75, null, 512), [
                                            [_directive_sanitize_html, conversation.createdName]
                                          ]),
                                          _hoisted_76,
                                          _createVNode("div", _hoisted_77, _toDisplayString(`${conversation.value.escalatePartnerCode} -
                  ${conversation.value.escalatePartnerName}`), 1),
                                          _hoisted_78,
                                          _withDirectives(_createVNode("div", _hoisted_79, null, 512), [
                                            [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                          ])
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_80, [
                                          _hoisted_81,
                                          _withDirectives(_createVNode("div", {
                                            class: ["font-semibold", _ctx.mapStatusTicket(conversation).style]
                                          }, null, 2), [
                                            [_directive_sanitize_html, _ctx.mapStatusTicket(conversation).label]
                                          ]),
                                          _createTextVNode(" " + _toDisplayString(_ctx.mapStatusTicket(conversation).madeBy) + " ", 1),
                                          _withDirectives(_createVNode("div", _hoisted_82, null, 512), [
                                            [_directive_sanitize_html, _ctx.userInformationLabel(conversation)]
                                          ]),
                                          _hoisted_83,
                                          _withDirectives(_createVNode("div", _hoisted_84, null, 512), [
                                            [_directive_sanitize_html, _ctx.getTime(conversation.createdAt)]
                                          ])
                                        ]))
                          ])),
                      (!group.isGroupingUnread && group.lastReadId === conversation.id && _ctx.isHighlight)
                        ? (_openBlock(), _createBlock("div", _hoisted_85, [
                            _hoisted_86,
                            _hoisted_87
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, ["id"]))
                }), 128))
              ]))
            }), 128))
          ]))
    ]),
    _createVNode(_component_ModalFinishIssue, {
      modelValue: _ctx.modalFinish,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modalFinish = $event)),
      onSubmit: _ctx.onSubmitFinish
    }, null, 8, ["modelValue", "onSubmit"]),
    _createVNode(_component_ModalSuccessFinish, {
      modelValue: _ctx.modalSuccessFinish,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalSuccessFinish = $event)),
      noIssue: _ctx.caseNumber
    }, null, 8, ["modelValue", "noIssue"])
  ], 64))
})